import { EventService } from 'src/app/shared/services/event/event.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { Component, ViewEncapsulation, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Event } from 'src/app/shared/models/event/event.model';
import ImageMap from 'image-map';
import { User } from '../../models/user/user.model';
import { Guest } from '../../models/event/eventSchedule.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent {
  public iconSidebar;
  public menuItems: Menu[];
  public url: any;
  public fileurl: any;
  public logo: string;
  public logoDark: string;
  public logoIcon: string;
  public fixed: boolean = false;
  public hovered: boolean = false;
  public currentEvent: Event;
  public userLogged: User;
  public guest: Guest;

  // For Horizontal Menu
  public margin: any = 0;
  public width: any = window.innerWidth;
  public leftArrowNone: boolean = true;
  public rightArrowNone: boolean = false;

  constructor(
    private router: Router,
    public navServices: NavService,
    private dbService: NgxIndexedDBService,
    private eventService: EventService,
    public util: UtilService,
    public layout: LayoutService
  ) {
    this.navServices.items.subscribe((menuItems) => {
      this.menuItems = menuItems;
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter((items) => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }
            if (!items.children) {
              return false;
            }
            items.children.filter((subItems) => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) {
                return false;
              }
              subItems.children.filter((subSubItems) => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
              });
            });
          });
        }
      });
    });
  }

  ngOnInit() {
    this.eventService.getCurrentEvent().then((ev: Event) => {
      if (ev) {
        this.currentEvent = ev;
        this.setLogo(ev.id);
        this.checkUserLogged();
      }
    });
  }

  setLogo(id: number) {
    setTimeout(() => {
      this.dbService.getByKey('Event', id).subscribe((e) => {
        if (e) {
          this.currentEvent = e as Event;
          this.logo = e.logo;
          this.logoDark = e.logoBlack;
          this.logoIcon = e.logoIcon;
        } else {
          this.logo = 'assets/images/logo/logo.png';
          this.logoDark = 'assets/images/logo/logo.png';
          this.logoIcon = 'assets/images/logo/logo-icon.png';
        }
      });
    }, 1000);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = event.target.innerWidth - 500;
  }

  sidebarToggle() {
    if (!this.hovered || this.util.isMobile()) {
      this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    }
    this.navServices.isFixedSidebar = !this.navServices.isFixedSidebar;
    this.fixed = this.navServices.isFixedSidebar;
    setTimeout(() => {
      ImageMap('img[usemap]');
    }, 1000);
  }

  @HostListener('mouseenter')
  sideBarToogleOnEnter() {
    if (!this.fixed) {
      this.navServices.collapseSidebar = false;
      this.hovered = true;
    }
  }

  @HostListener('mouseleave')
  sideBarToogleOnLeave() {
    if (!this.fixed) {
      this.navServices.collapseSidebar = true;
      this.hovered = false;
    }
  }

  // Active Nave state
  setNavActive(item) {
    this.menuItems.filter((menuItem) => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter((submenuItems) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach((a) => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) {
          return false;
        }
        a.children.forEach((b) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }

  // For Horizontal Menu
  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -3051) {
      this.margin = -3464;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }

  onDone() {
    localStorage.setItem('viewedTour', 'true');
  }

  checkUserLogged(): void {
    this.dbService.getAll('User').subscribe((users) => {
      if (users && users.length) {
        this.userLogged = users[0] as User;

        this.dbService
          .getAllByIndex(
            'Guest',
            'eventScheduleId',
            IDBKeyRange.only(this.currentEvent.id)
          )
          .subscribe((guests) => {
            if (guests)
              this.guest = guests.filter(
                (x) => x.userSgunId == this.userLogged.id
              )[0];
          });
      }
    });
  }
}
